import React, { Component } from "react";
import {
  View,
  TouchableOpacity,
  Image,
  Platform,
  Text,
} from "react-native";
import moment from "moment";
import { connect } from "react-redux";

import ParallaxScrollView from "react-native-parallax-scroll-view";
import Timeline from "react-native-timeline-flatlist";

import Header from "../components/Header";
import fonts from "../constants/fonts";
import PatientAvatarWithDetail from "../components/PatientAvatarWithDetail";
import PrescriptionHistoryOrderStatusDetail from "../components/PrescriptionHistoryOrderStatusDetail";

class PrescriptionHistoryDetailStatusScreen extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { data } = this.props.navigation.state.params;
    return (
      <ParallaxScrollView
        ref={(ref) => {
          this.scrollRef = ref;
        }}
        backgroundColor={this.props.themeColors.primary}
        parallaxHeaderHeight={200}
        renderForeground={() => (
          <View>
            <Header
              onPress={() => {
                this.props.navigation.goBack();
              }}
              position="start"
              text="Kembali"
              theme="light"
            />
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                padding: 20,
              }}
            >
              <PatientAvatarWithDetail
                cardNumber={this.props.navigation.state.params.cardNumber}
                fullName={this.props.navigation.state.params.fullName}
                gender={this.props.navigation.state.params.gender}
              />
              <TouchableOpacity
                style={{ marginStart: 20 }}
                onPress={() => this.scrollRef.scrollTo({ x: 0, y: 500 })}
              >
                <Image
                  source={require("../assets/baseline_keyboard_arrow_up_white_18dp.png")}
                />
              </TouchableOpacity>
            </View>
          </View>
        )}
      >
        <View style={{ backgroundColor: this.props.themeColors.primary }}>
          <View
            style={{
              backgroundColor: "#FFF",
              borderTopEndRadius:
                Platform.OS === "android" && Platform.Version <= 26 ? 0 : 40,
              borderTopStartRadius:
                Platform.OS === "android" && Platform.Version <= 26 ? 0 : 40,
              paddingTop: 16,
            }}
          >
            <Text
              style={{
                fontSize: 20,
                ...fonts.bold,
                color: this.props.themeColors.darkestPrimary,
                alignSelf: "center",
                marginBottom: 30,
              }}
            >
              DETAIL STATUS PESANAN
            </Text>
            <Timeline
              innerCircle="icon"
              circleColor={this.props.themeColors.lighterPrimary}
              lineColor={this.props.themeColors.primary}
              data={data}
              detailContainerStyle={{ marginTop: -13, marginBottom: 13 }}
              listViewContainerStyle={{ marginLeft: 12, marginRight: 32 }}
              renderDetail={(rowData, rowID) => {
                return (
                  <PrescriptionHistoryOrderStatusDetail
                    date={moment(rowData.timestamp).toDate()}
                    status={rowData.status}
                    isLargeDetail={rowID === 0}
                    rejectReason={rowData.reject_reason}
                  />
                );
              }}
              showTime={false}
            />
          </View>
        </View>
      </ParallaxScrollView>
    );
  }
}

export default connect((state) => ({
  themeColors: state.themeColors,
}))(PrescriptionHistoryDetailStatusScreen);
